import { IKeyStringAndValue } from "../../types/Types";

const resetFilter = (
  data: Array<IKeyStringAndValue>,
  setFilteredData: React.Dispatch<
    React.SetStateAction<Array<IKeyStringAndValue>>
  >,
  setFilterOptions: React.Dispatch<React.SetStateAction<IKeyStringAndValue>>,
  setCurrentPage: React.Dispatch<React.SetStateAction<number | string>>,
  setInputValue: React.Dispatch<React.SetStateAction<string>>,
  setFirstFilterValue: React.Dispatch<React.SetStateAction<string | undefined>>,
  isPumpView?: boolean
) => {
  setFirstFilterValue("");
  setFilteredData(data);
  isPumpView ? null : setFilterOptions({});
  setCurrentPage(1);
  setInputValue("");
};
export default resetFilter;
